const CrudMixin = {
  methods: {
    async _validateForm(refNames = []) {
      return new Promise((resolve, reject) => {
        Promise.all(refNames.map(i => this.$refs[i].validate())).then(res => {
          resolve(res)
        }).catch((e) => {
          console.error('校验失败')
          reject(e)
        })
      })
    },
  }
}

export default CrudMixin
